(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured_in_slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded",function(){if(typeof Swiper==="undefined"){console.error("Swiper JS is not loaded.");return;}new Swiper(".marquee-swiper",{slidesPerView:"auto",spaceBetween:80,loop:true,speed:1500,allowTouchMove:false,autoplay:{delay:1,disableOnInteraction:false},breakpoints:{320:{spaceBetween:30},600:{spaceBetween:40},780:{spaceBetween:40},1100:{spaceBetween:80}}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fmslideshow"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      var swiper = new Swiper('.fmhero_slider .swiper-container', {
        loop: true,
        speed:1000,
        autoplay: {
          delay:5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.fmhero_slider .swiper-button-next',
          prevEl: '.fmhero_slider .swiper-button-prev',
        },
        pagination: {
          el: '.fmhero_slider .swiper-pagination',
          clickable: true,
        },
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.custom-tab').forEach(tab => {
  tab.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-thumb-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    $('.video-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: !0 } },
          { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
    var swiper = new Swiper(".video-slider-sw .swiper-container", {
        slidesPerView:4,
        spaceBetween:20,
        lazy:true,
        //loop:true,
        centerInsufficientSlides: true,
        preloadImages:false,
        observer:true,
        observeParents:true,
        speed: 800,
        freeMode: true,
        freeModeSticky: false,
        mousewheel: {
          enabled: true,
          releaseOnEdges: true,
          forceToAxis: true,
          sensitivity:1, 
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: ".video-slider-sw .swiper-button-next",
          prevEl: ".video-slider-sw .swiper-button-prev",
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: {
          320: {
            slidesPerView:1.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView:2.2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView:3.2,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView:4,
            spaceBetween: 20,
          },
        },
    });
});
  
$(document).ready(function() {
  $('.video-item').click(function() {
    var videoType = $(this).data('video-type');
    var videoUrl = $(this).data('video-url');
    if (videoType === 'instagram') {
      // Open Instagram video in a new tab
      window.open(videoUrl, '_blank');
    } else {
      var videoSrc = '';

      if (videoType === 'youtube') {
        // YouTube embed URL with autoplay
        videoSrc = 'https://www.youtube.com/embed/' + videoUrl + '?autoplay=1';
      } else if (videoType === 'local' || videoType === 'url') {
        // Local video or external URL (direct link to the video)
        videoSrc = videoUrl;
      }

      // For local videos or YouTube, embed them in the popup
      var iframeHtml = '';
      if (videoType === 'youtube') {
        // Embed YouTube video in an iframe
        iframeHtml = '<iframe width="300" height="520" src="' + videoSrc + '" frameborder="0" allowfullscreen></iframe>';
      } else if (videoType === 'local') {
        // Embed local video in a video player
        iframeHtml = '<video controls autoplay width="300" height="520"><source src="' + videoSrc + '" type="video/mp4"></video>';
      }

      // Insert the video into the popup and show the popup
      $('#video-player').html(iframeHtml);
      $('#video-popup').fadeIn();
    }
  });

  // Close popup functionality
  $('.close-popup').click(function() {
    // Clear the video content and hide the popup
    $('#video-player').empty();
    $('#video-popup').fadeOut();
  });
});


  } catch(e) { console.error(e); }
})();
})();
